/* eslint-disable import/extensions */

import { useMemo, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { isValidCIF, isValidNIF, isValidNIE, isValidPassport } from '@masfront/common-b2c'
import { getIn, useFormikContext } from 'formik'

import { UseDonorOwner } from '../../model/line.model'

import { SignUpType, Owner } from '~/basket/model/lines/signup.model'
import { selectDocId } from '~/customer/store/customer.selectors'

export default function useDonorOwner(): UseDonorOwner {
  const owners = [
    { value: Owner.SAME, label: 'El nuevo titular' },
    { value: Owner.OTHER, label: 'Otra persona' },
  ]

  const { values, setFieldValue, setFieldTouched, validateField } = useFormikContext()

  const customerDoc = useSelector(selectDocId)

  const donorDocId = getIn(values, 'donorOwner.docId')

  const docType = useMemo(() => {
    if (isValidNIF(donorDocId)) return 'NIF'
    if (isValidCIF(donorDocId)) return 'CIF'
    if (isValidNIE(donorDocId)) return 'NIE'
    if (isValidPassport(donorDocId)) return 'PASS'
    return ''
  }, [donorDocId])

  const isPortability = getIn(values, 'signUpType') === SignUpType.PORTABILITY
  const showDonorOwner = getIn(values, 'isSameOwner') === Owner.OTHER && isPortability
  const showPersonalInputs = docType !== 'CIF'

  useEffect(() => {
    setFieldValue(`donorOwner.docType`, docType)
  }, [docType, setFieldValue])

  useEffect(() => {
    if (donorDocId?.toUpperCase() !== donorDocId) {
      setFieldValue(`donorOwner.docId`, donorDocId?.toUpperCase())
    }
  }, [setFieldValue, donorDocId])

  useEffect(() => {
    if (!!customerDoc && !!donorDocId) {
      setFieldTouched('donorOwner.docId')
      validateField('donorOwner.docId')
    }
  }, [customerDoc])

  return { docType, showDonorOwner, showPersonalInputs, owners }
}
